import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../context/LanguageContext";

export function useStock() {
  const [stock, setStock] = useState(null);
  useEffect(() => { api.get("/stock").then((r) => setStock(r.data)).catch(() => {}); }, []);
  return stock;
}

export function StockBadge({ className = "" }) {
  const stock = useStock();
  const { t } = useLang();
  if (!stock) return null;
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="stock-badge">
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-60" style={{ background: "var(--lo-rose)" }} />
        <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: "var(--lo-rose-hi)" }} />
      </span>
      <span className="overline" style={{ fontSize: "0.6rem", color: "var(--lo-muted)" }}>
        {t("stock.prefix")}<span style={{ color: "var(--lo-rose-hi)" }}>{stock.remaining}</span>{t("stock.suffix")}
      </span>
    </div>
  );
}
